export default "__VITE_ASSET__1upH1pfb__"